import React from 'react';

interface SpinnerProps {
    size?: 'small' | 'medium' | 'large';
    color?: string;
}

const Spinner: React.FC<SpinnerProps> = ({size = 'medium', color = 'white-500'}) => {
    return (
        <div className="flex justify-center items-center h-screen">
            <div
                className={`
                    rounded-full animate-spin
                    border-t-primary-color
                    ${size === 'small' ? 'w-4 h-4 border-2' : ''}
                    ${size === 'medium' ? 'w-8 h-8 border-4 md:w-16 md:h-16 md:border-8' : ''}
                    ${size === 'large' ? 'w-12 h-12 border-6 md:w-20 md:h-20 md:border-8 lg:w-28 lg:h-28 lg:border-8' : ''}
                    border-${color}
                `}
            ></div>
        </div>
    );
};

export default Spinner;